/**
 *
 * AuditWriteLog
 *
 */

import AuditWriteLog from './AuditWriteLog.jsx';
import './AuditWriteLog.less';

export default AuditWriteLog;
